module.exports = __webpack_public_path__ + "static/media/kruk.e12ced03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/kruk.svg
// module id = 397
// module chunks = 0